(function (factory) {

	if (typeof define === "function" && define.amd)
		define('bootstrap.popover',["jquery", "bootstrap"], factory);
	else
		factory(jQuery);

}(function ($) {
	"use strict";

	if (typeof $ != "function")
		throw "jQuery plugin is required.";

	if (typeof $.fn.popover != "function")
		throw "Popover plugin is not loaded.";

	$(function () {
		$("[data-toggle='popover']").each(function() {
			var $element = $(this);
			if (!$element.data("bs.popover")) {

				// fix for offset
				var __getCalculatedOffset = $.fn.popover.Constructor.prototype.getCalculatedOffset;
				$.fn.popover.Constructor.prototype.getCalculatedOffset = function(placement, pos, actualWidth, actualHeight) {
					var result = __getCalculatedOffset.apply(this, arguments);

					if ((result.left + actualWidth + 15) > $(window).width()) {
						result.left = $(window).width() - actualWidth - 15;
					}

					result.top = result.top - 15;

					return result;
				};

				$element.popover();

				$(window).on("resize", function () {
					if ($element.data("bs.popover") && $element.data("bs.popover").$tip && $element.data("bs.popover").$tip.is(":visible"))
						$element.popover("hide");
				});
			}
		});
	});

}));
